/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import ApiCaller from "~/api/ApiCaller";
import { GetComplianceStatusResponse, GetHasPaymethodResponseData } from "~/features/userGuide/types";

const UserGuideApi = {
  getComplianceStatus: () => ApiCaller.get<GetComplianceStatusResponse>("/v1/resellercompliance/resellerstatus"),

  getHasPaymethod: () => ApiCaller.get<GetHasPaymethodResponseData>("/v1/resellercompliance/haspaymethod"),
};

export default UserGuideApi;
